import { createSelector } from '@ngrx/store';
import { Reducers } from '@app/reducers';

export const currentRouteFeature = (state: Reducers) => state.router;

export const getCurrentRouteId = createSelector(
  currentRouteFeature,
  (state: any) => state ? state.navigationId : null
);

export const getCurrentRouteUrl = createSelector(
  currentRouteFeature,
  (state: any) => state.state.url
);
